<template>
  <div class="wameed-dashboard-page-content">
    <page-header
      :title="$t('settings.platform_controls.title')"
      :paths="[{ title: $t('settings.title'), link: 'settings' }]"
    />

    <section class="wameed-dashboard-page-content_body">
      <b-row class="px-2">
        <b-col cols="12" class="px-0">
          <b-card no-body class="wameed-card platform-controls-card">
            <b-card-header class="align-items-start tab-title">
              <h5 class="text-med-20 text-font-main mb-0">
                {{ $t('settings.platform_controls.title') }}
              </h5>
            </b-card-header>

            <b-card-body class="px-4 py-4">
              <div class="platform-control-row">
                <label class="platform-control-label mb-0">
                  {{ $t('settings.platform_controls.chat_enabled') }}
                </label>
                <WameedSwitch
                  :checked="form.chat_enabled"
                  @onChange="form.chat_enabled = !form.chat_enabled"
                />
              </div>

              <div class="platform-control-row platform-control-row-stacked">
                <label class="platform-control-label">
                  {{ $t('settings.platform_controls.delivery_distance_provider') }}
                </label>
                <b-form-radio-group
                  v-model="form.delivery_distance_provider"
                  :options="distanceProviderOptions"
                  buttons
                  button-variant="outline-primary"
                  class="platform-provider-options"
                />
              </div>
            </b-card-body>

            <b-card-footer class="px-4 py-3">
              <WameedBtn
                v-permission="[pagePermissions.edit, permissions.general_settings]"
                variant="main"
                classes="text-med-14 text-white rounded-10"
                :title="$t('common.save')"
                @onClick="save"
              />
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import { permissions as permissionsEnum } from '@/enums/permissions.enum';
import { WameedBtn, WameedSwitch } from 'wameed-ui/dist/wameed-ui.esm';

export default {
  components: {
    PageHeader,
    WameedBtn,
    WameedSwitch
  },
  data() {
    return {
      form: {
        chat_enabled: true,
        delivery_distance_provider: 'straight_line'
      },
      pagePermissions: this.$route.meta.pagePermissions,
      permissions: permissionsEnum
    };
  },
  computed: {
    distanceProviderOptions() {
      return [
        {
          text: this.$t('settings.platform_controls.google_routes'),
          value: 'google_routes'
        },
        {
          text: this.$t('settings.platform_controls.straight_line'),
          value: 'straight_line'
        }
      ];
    }
  },
  async created() {
    try {
      const settings = await this.$store.dispatch('admin/settings/general/getPlatformFeatures');
      this.form = { ...this.form, ...settings };
    } catch (error) {
      this.$store.commit('loadingFinish', null, { root: true });
    }
  },
  methods: {
    async save() {
      const settings = await this.$store.dispatch(
        'admin/settings/general/updatePlatformFeatures',
        this.form
      );
      this.form = { ...settings };
    }
  }
};
</script>

<style scoped>
.platform-controls-card {
  max-width: 900px;
}

.platform-control-row {
  align-items: center;
  border-bottom: 1px solid #e8ebf0;
  display: flex;
  justify-content: space-between;
  min-height: 72px;
  padding: 12px 0;
}

.platform-control-row:last-child {
  border-bottom: 0;
}

.platform-control-row-stacked {
  align-items: flex-start;
  flex-direction: column;
  gap: 14px;
}

.platform-control-label {
  color: #313745;
  font-size: 16px;
  font-weight: 600;
}

.platform-provider-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 576px) {
  .platform-control-row {
    gap: 12px;
  }

  .platform-provider-options {
    width: 100%;
  }
}
</style>
